"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,2 C6.47727273,2 2,6.47727273 2,12 C2,17.5227273 6.47727273,22 12,22 C17.5227273,22 22,17.5227273 22,12 C22,6.47727273 17.5227273,2 12,2 Z M11,5.8988764 C11,5.40449438 11.45,5 12,5 C12.55,5 13,5.40449438 13,5.8988764 L13,14.1011236 C13,14.5955056 12.55,15 12,15 C11.45,15 11,14.5955056 11,14.1011236 L11,5.8988764 Z M12,18 C11.452381,18 11,17.547619 11,17 C11,16.452381 11.452381,16 12,16 C12.547619,16 13,16.452381 13,17 C13,17.547619 12.5714286,18 12,18 Z",
    transform: "matrix(1 0 0 -1 0 24)"
  });
}.bind(void 0));

exports.default = _default;